module.exports = __webpack_public_path__ + "static/media/img26.99971eb9.jpg";